var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase, List } from "survey-react-ui";
var ObjectSelectorComponent = /** @class */ (function (_super) {
    __extends(ObjectSelectorComponent, _super);
    function ObjectSelectorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ObjectSelectorComponent.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    ObjectSelectorComponent.prototype.getStateElement = function () {
        return this.model;
    };
    ObjectSelectorComponent.prototype.renderElement = function () {
        if (!this.model.isVisible)
            return null;
        return (React.createElement(List, { model: this.model.list }));
    };
    return ObjectSelectorComponent;
}(SurveyElementBase));
ReactElementFactory.Instance.registerElement("svc-object-selector", function (props) {
    return React.createElement(ObjectSelectorComponent, props);
});
